import PropTypes from 'prop-types';
import React from 'react';
import { Button, FormControl, InputLabel } from '@material-ui/core';
import { AddCircleOutline } from '@mui/icons-material';
import FormLabel from '@material-ui/core/FormLabel';

import { DeedRole, DurationUnit } from 'entities/deed/role';
import { DeedType } from 'generated/graphql';

import FormRole from './FormRole';

const FormRoles = ({
  deed,
  disabled,
  fields,
  formValues,
  labelText,
  selectedDeedType,
  skills,
  timeZone,
  meta,
}) => {
  const deedType = selectedDeedType ?? deed?.type;
  const hasShiftsInsteadOfRoles = [DeedType.Event, DeedType.BaseEvent].includes(deedType);

  return (
    <>
      <div>
        {labelText && (
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>{labelText}</InputLabel>
          </FormControl>
        )}

        {fields.map((role, index) => {
          const remove = () => fields.remove(index);
          return (
            <FormRole
              key={role.id || index}
              role={role}
              skills={skills}
              deed={deed}
              formValues={formValues}
              index={index}
              selectedDeedType={selectedDeedType}
              timeZone={timeZone}
              remove={remove}
              disabled={disabled}
              move={fields.move}
            />
          );
        })}
        <Button
          type="button"
          onClick={() =>
            fields.push(
              new DeedRole({
                durationUnit: hasShiftsInsteadOfRoles ? DurationUnit.hours : DurationUnit.weeks,
                autoApproval: hasShiftsInsteadOfRoles,
                requiredAmount: undefined,
                durationMin: undefined,
                durationMax: undefined,
                estimatedHoursMin: undefined,
                estimatedHoursMax: undefined,
                estimatedValue: undefined,
              })
            )
          }
          color="primary"
          variant="contained"
          size="small"
          style={{ marginTop: 15, paddingRight: 15 }}
          disabled={disabled}
          endIcon={<AddCircleOutline />}
        >
          {hasShiftsInsteadOfRoles ? 'Add shift' : 'Add role'}
        </Button>
      </div>
      {meta.error && (meta.dirty || meta.submitFailed) && (
        <FormLabel error style={{ fontSize: 12, marginTop: 10 }}>
          {meta.error}
        </FormLabel>
      )}
    </>
  );
};
FormRoles.propTypes = {
  deed: PropTypes.object,
  disabled: PropTypes.bool,
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object,
  formValues: PropTypes.object,
  labelText: PropTypes.string,
  selectedDeedType: PropTypes.string,
  skills: PropTypes.object,
  timeZone: PropTypes.string,
};

export default FormRoles;
